import { useEffect } from "react";
import { iosSetBackgroundColor, isIOSApp } from "../../../tools/ios";
import ContentHeader from "./ContentHeader";
import { Button } from "../../ui/Button";
import { IconCheck } from "@tabler/icons-react";

export default function SaveHeader({
  title,
  saveReady,
  onSaveClick,
  onGoBack,
}: {
  title: string;
  saveReady: boolean;
  onSaveClick: () => void;
  onGoBack?: () => void;
}) {
  useEffect(() => {
    if (isIOSApp()) iosSetBackgroundColor("#FFFFFF");
  }, []);

  return (
    <ContentHeader
      transparent
      title={title}
      onBack={onGoBack}
      className="md:block!"
      actions={
        <Button
          size="xs"
          mode="iconOnly"
          className="px-2! transition-opacity!"
          variant="ghost"
          disabled={!saveReady}
          onClick={onSaveClick}
        >
          <IconCheck className="size-6! stroke-[1.75px]!" />
        </Button>
      }
    />
  );
}
